import * as moment from 'moment'
import { ImportStatus } from './import.status.enum'

export interface Import {
    id: number
    start: moment.Moment
    end?: moment.Moment | null
    status: ImportStatus
}

export interface ImportDto {
    id: number
    start: string
    end?: string | null
    status: string
}

export interface ImportCriteria {
    startDate: moment.Moment | null
    endDate: moment.Moment | null
    employeeId: number | null
    projectId: number | null
    edited: boolean
    deleted: boolean
}

export interface ImportCriteriaDto {
    startDate: string | null
    endDate: string | null
    employeeId: number | null
    projectId: number | null
    edited: boolean
    deleted: boolean
}

export const importCriteriaToDto = (model: ImportCriteria): ImportCriteriaDto => ({
    ...model,
    startDate: model.startDate?.format() ?? null,
    endDate: model.endDate?.format() ?? null
})

export const importFromDto = (dto: ImportDto): Import => ({
    ...dto,
    end: dto.end ? moment(dto.end) : null,
    start: moment(dto.start),
    status: dto.status as ImportStatus
})
